/**
 * Whether the signed-in user's partner has a feature flag on, with the same rule the sidebar and
 * router apply to `requiresPartnerFeature` (`navmenu.vue` / `router/index.ts`): partner settings
 * come from `localStorage.userAddData`; `openForInternalUsers` mirrors
 * `partnerFeatureOpenForInternalUsers` (ryd-internal users have no partner settings).
 */
export function hasPartnerFeature(
  flag: string,
  { openForInternalUsers = false }: { openForInternalUsers?: boolean } = {},
  userAddData: Record<string, any> | null = readUserAddData(),
): boolean {
  const isInternalUser =
    (userAddData?.partnerTypes || []).includes('RYD_INTERNAL') || userAddData?.userGroup === 'ryd';
  if (openForInternalUsers && isInternalUser) return true;
  return userAddData?.partnerSettings?.featureFlags?.[flag] === true;
}

function readUserAddData(): Record<string, any> | null {
  try {
    const raw = localStorage.getItem('userAddData');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
